module.exports = __webpack_public_path__ + "img/muglo-currency-guide-2.812f0845.png";